/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { WorkAmounts } from './';
import {
    WorkAmountsFromJSON,
    WorkAmountsFromJSONTyped,
    WorkAmountsToJSON,
} from './';

/**
 * Is present if activityType = DETAILED
 * @export
 * @interface ActivityTrackerResourceDetailedTimeWorked
 */
export interface ActivityTrackerResourceDetailedTimeWorked {
    /**
     * 
     * @type {Array<WorkAmounts>}
     * @memberof ActivityTrackerResourceDetailedTimeWorked
     */
    workAmounts: Array<WorkAmounts>;
}

/**
 * Check if a given object implements the ActivityTrackerResourceDetailedTimeWorked interface.
 */
export function instanceOfActivityTrackerResourceDetailedTimeWorked(value: object): value is ActivityTrackerResourceDetailedTimeWorked {
    if (!('workAmounts' in value) || value['workAmounts'] === undefined) return false;
    return true;
}

export function ActivityTrackerResourceDetailedTimeWorkedFromJSON(json: any): ActivityTrackerResourceDetailedTimeWorked {
    return ActivityTrackerResourceDetailedTimeWorkedFromJSONTyped(json, false);
}

export function ActivityTrackerResourceDetailedTimeWorkedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityTrackerResourceDetailedTimeWorked {
    if (json == null) {
        return json;
    }
    return {
        
        'workAmounts': ((json['workAmounts'] as Array<any>).map(WorkAmountsFromJSON)),
    };
}

export function ActivityTrackerResourceDetailedTimeWorkedToJSON(value?: ActivityTrackerResourceDetailedTimeWorked | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workAmounts': ((value['workAmounts'] as Array<any>).map((v) => WorkAmountsToJSON(v))),
    };
}

